import React from 'react';
import { CheckCircle } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function IncludedSection() {
  const items = ['Done-for-you custom build for your business', 'Mobile responsive + SEO-ready structure', 'Contact form + WhatsApp click-to-chat + Google Maps', 'Basic analytics setup', '1-year Magic Patterns Hobby Plan included ($180 value)', '100 AI requests per month for edits', 'Up to 3 rounds of revisions', '1 year of fast, reliable hosting included', '1 year of direct support via WhatsApp & LINE'];
  return <section id="included" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#080808'
  }} data-id="element-390">
      <div className="max-w-5xl mx-auto" data-id="element-391">
        <div className="text-center mb-12 reveal" data-id="element-392">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-393">
            Everything Included In Your Dublin Website Package
          </h2>
          <p className="text-white/60" data-id="element-394">
            No hidden fees. Everything you need to launch.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 reveal" data-id="element-395">
          {items.map((item, idx) => <div key={idx} className="flex items-start space-x-4 p-4 rounded-lg border border-white/[0.06] hover:border-[#c9a84c]/30 transition-colors" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.03)'
        }} data-id="element-396">
              <CheckCircle className="w-6 h-6 text-[#c9a84c] flex-shrink-0 mt-0.5" data-id="element-397" />
              <span className="text-white text-lg" data-id="element-398">{item}</span>
            </div>)}
        </div>

        <div className="mt-8 text-center reveal" data-id="element-399">
          <p className="text-sm text-white/40 italic" data-id="element-400">
            * Domain purchased separately by client — or we can purchase and set
            it up for you at an extra cost.
          </p>
        </div>
      </div>
      <SectionDivider data-id="element-401" />
    </section>;
}